import React, { useState } from "react";
import ChatBot from "./Chatbot";
import { useSiteConfig } from "../context/SiteConfigContext";

const FloatingIcons = () => {
  const { siteConfig } = useSiteConfig();
  const [openChat, setOpenChat] = useState(false);

  return (
    <>
      <div className={`side-floating-bar ${openChat ? "chat-open" : ""}`}>
        <div className="floating-item item-admission active">
          <a href="#">
            <span className="floating-text">
              Admission Open {siteConfig.admission_batch}
            </span>
            <div className="floating-icon">
              <i className="bi bi-megaphone-fill" />
            </div>
          </a>
        </div>

        <div className="floating-item floating-item2 item-whatsapp">
          <a
           href={`https://wa.me/${siteConfig.whatsapp}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="floating-text">Connect on WhatsApp</span>
            <div className="floating-icon">
              <i className="bi bi-whatsapp" />
            </div>
          </a>
        </div>

        {/* <div
          className="floating-item floating-item3 item-chat"
          onClick={() => setOpenChat(true)}
        >
          <a href="#">
            <span className="floating-text">Chat with Us</span>
            <div className="floating-icon">
              <i className="bi bi-chat-dots-fill" />
            </div>
          </a>
        </div> */}
      </div>

      <ChatBot isOpen={openChat} closeChat={() => setOpenChat(false)} />
    </>
  );
};

export default FloatingIcons;
